import { UtilsMisc } from '../../utils/utils.misc';

export interface IConfigCommChannel {

    ip?: string;
    port?: string;
    protocol?: string;
    timeout?: number;
    urlApi?: string;
    urlChannel?: string;
    useChannel?: boolean;
    version?: string;

}

// @dynamic
export class ConfigCommChannel {

    private static _ip: string = 'localhost';
    private static _port: string = '5001';
    private static _protocol: string = 'http';
    private static _timeout: number = 2000;
    private static _urlApi: string = 'api';
    private static _urlChannel: string = null;
    private static _useChannel: boolean = false;
    private static _version: string = null;

    public static get ip(): string {
        return ConfigCommChannel._ip;
    }

    public static set ip(value: string) {
        ConfigCommChannel._ip = value;
    }

    public static get port(): string {
        return ConfigCommChannel._port;
    }

    public static set port(value: string) {
        ConfigCommChannel._port = value;
    }

    public static get protocol(): string {
        return ConfigCommChannel._protocol;
    }

    public static set protocol(value: string) {
        ConfigCommChannel._protocol = value;
    }

    public static get timeout(): number {
        return ConfigCommChannel._timeout;
    }

    public static set timeout(value: number) {
        ConfigCommChannel._timeout = value;
    }

    public static get urlApi(): string {
        return ConfigCommChannel._urlApi;
    }

    public static set urlApi(value: string) {
        ConfigCommChannel._urlApi = value;
    }

    public static get urlChannel(): string {
        return ConfigCommChannel._urlChannel;
    }

    public static set urlChannel(value: string) {
        ConfigCommChannel._urlChannel = value;
    }

    public static get useChannel(): boolean {
        return ConfigCommChannel._useChannel;
    }

    public static set useChannel(value: boolean) {
        ConfigCommChannel._useChannel = value;
    }

    public static get version(): string {
        return ConfigCommChannel._version;
    }

    public static set version(value: string) {
        ConfigCommChannel._version = value;
    }

    public static assign(source: IConfigCommChannel): void {
        if (UtilsMisc.isNullOrUndefinedOrEmpty(source) === false) {
            ConfigCommChannel._ip = source.ip;
            ConfigCommChannel._port = source.port;
            ConfigCommChannel._protocol = source.protocol;
            ConfigCommChannel._timeout = source.timeout;
            ConfigCommChannel._urlApi = source.urlApi;
            ConfigCommChannel._urlChannel = source.urlChannel;
            ConfigCommChannel._useChannel = source.useChannel;
            ConfigCommChannel._version = source.version;
        }
    }

}
